import { render, staticRenderFns } from "./spot-crew.vue?vue&type=template&id=4a4d9816&scoped=true&lang=pug"
import script from "./spot-crew.vue?vue&type=script&lang=js"
export * from "./spot-crew.vue?vue&type=script&lang=js"
import style0 from "./spot-crew.vue?vue&type=style&index=0&id=4a4d9816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4d9816",
  null
  
)

export default component.exports